import { useEffect, useState } from "react";
import { useWeb3 } from "@chainsafe/web3-context";
import { getAddress } from "@ethersproject/address/lib/index.js";
import { INft } from "../../../commonTypes";
import { useContracts } from "../../../../context/Contracts";
import { captureException } from "@sentry/nextjs";

interface IReturnValue {
  isWalletConnected: boolean;
  isOwner: boolean;
  isCheckingOwnership: boolean;
}

export const useNftOwnershipCheck = (nft?: INft): IReturnValue => {
  const { address, provider } = useWeb3();
  const [isOwner, setIsOwner] = useState(false);
  const [isCheckingOwnership, setIsCheckingOwnership] = useState(false);
  const isWalletConnected = !!address;
  const { nftContracts } = useContracts();

  useEffect(() => {
    if (address && provider && nft?.metadata.id) {
      const deployment = nft?.listing.deployment;
      const nftContract = nftContracts[deployment.id];
      const checkOwnerAddress = async () => {
        try {
          setIsCheckingOwnership(true);

          const ownerAddress = await nftContract?.ownerOf(nft.metadata.id);
          setIsOwner(getAddress(ownerAddress) === getAddress(address));
        } catch (error) {
          captureException(error);
        } finally {
          setIsCheckingOwnership(false);
        }
      };

      if (nftContract?.address) {
        checkOwnerAddress();
      }
    }
  }, [address, provider, nft?.metadata.id, nftContracts?.length]);

  return {
    isWalletConnected,
    isOwner: isWalletConnected && isOwner,
    isCheckingOwnership,
  };
};
